<template>
  <div class="container-fluid pb-0 pt-2 bg-light">
    <div class="row m-3 align-items-center">
      <div class="col-xxl-3 col-12 nmt5">
        <p>CONTACT US</p>
        <h4 class="font-weight-lighter text-dark">
          MELANGE INTERIORS LTD
        </h4>
        <p
          class="foot-font"
          style="line-height:1.5;"
        >
          Rm 701, Far East Consortium Bldg,<br>113-125 Des Voeux Road<br>Central, Hong Kong, China.<br>TEL:+852 2153 9800
        </p>
      </div>
      <div class="col-xxl-4 col-12 nmt5">
        <h4 class="font-weight-lighter text-dark">
          STUDIO
        </h4>
        <p
          class="foot-font"
          style="line-height:1.5;"
        >
          Unit 8-10,8/F Paramount Bldg,<br>12 Ka Yip St. Chai Wan, Hong Kong, China.
        </p>
      </div>
      <div class="col-xxl-5 col-12 folter">
        <p>FOLLOW US</p>
        <h4 class="font-weight-lighter text-dark">
          <a
            href="https://www.instagram.com/melange_style"
            class="text-decoration-none link-secondary"
            target="_blank"
          >@melange_style</a><br><a
            href="https://www.instagram.com/anjasilling.collection/"
            class="text-decoration-none link-secondary"
            target="_blank"
          >@anjasilling.collection</a>
        </h4>
        <p style="line-height:2.5;">
          <img :src="`${laravel_url}assets/images/Group 5.png`">
        </p>
      </div>
    </div>
    <div class="row mx-3 my-2">
      <div class="col-xxl-7 col-12 foot-font">
        <p>&copy;2021 Melange Art Consultancy.  All Right Reserved.</p>
      </div>
      <div class="col-xxl-5 col-12 folter foot-font">
        <!-- <p>
          <a
            class="text-decoration-none link-secondary"
            @click="goTo('Privacy')"
          >Privacy Policy</a> &nbsp; <a
            class="text-decoration-none link-secondary"
            @click="goTo('T&C')"
          >Terms &amp; Conditions</a> &nbsp; <a
            class="text-decoration-none link-secondary"
            @click="goTo('ShippingTerms')"
          >Shipping Terms</a>
        </p> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrFooter',
  data: function () {
    let date = new Date()
    return {
      year: date.getFullYear(),
      laravel_url: window.LARAVEL_URL
    }
  },
  methods: {
    goTo (name) {
      this.$router.push({ name: name })
    }
  }
}
</script>

<style scoped>
.poiret {
  font-family: 'Poiret One';
  font-size: large;
}
.white-text {
    color: white;
}
i {
    cursor: pointer;
}
</style>
